module.exports = __webpack_public_path__ + "static/how-it-works-step-3.3436e453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/how-it-works-step-3.png
// module id = 953
// module chunks = 214286880276331